import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
    <App/>, document.getElementById("root"));

// This app intentionally does NOT use a service worker. A cache-first service
// worker previously pinned some users to a stale version that survived hard
// refreshes. unregister() ensures any existing worker is torn down and none is
// (re)installed. See public/service-worker.js for the self-destroying worker
// that evicts already-installed workers on legacy clients.
serviceWorker.unregister();
